export const faq = [

  // =========================
  // 🧠 TEA (AUTISMO)
  // =========================
  {
    id: "tea-1",
    category: "TEA",
    question: "Mi hijo no responde cuando lo llaman, ¿es autismo?",
    answer:
      "No necesariamente. Puede estar relacionado con atención, desarrollo del lenguaje o posibles señales del espectro autista. Lo importante es observar si también hay dificultades en interacción social, juego y comunicación.",
    recommendations: [
      "Observar contacto social en distintos contextos",
      "Consultar evaluación de neurodesarrollo",
      "No asumir diagnóstico sin valoración profesional"
    ],
    source: "OMS / ICBF"
  },

  {
    id: "tea-2",
    category: "TEA",
    question: "¿Por qué mi hijo no habla todavía?",
    answer:
      "El retraso del lenguaje puede ser parte del desarrollo o estar asociado a condiciones del neurodesarrollo como el TEA. Cada niño tiene su propio ritmo.",
    recommendations: [
      "Estimular lenguaje diario",
      "Evitar pantallas prolongadas",
      "Consultar fonoaudiología si no hay progreso"
    ],
    source: "MEN Colombia"
  },

  {
    id: "tea-3",
    category: "TEA",
    question: "¿Qué hago si mi hijo tiene crisis o berrinches intensos?",
    answer:
      "Las crisis en TEA suelen estar relacionadas con sobrecarga sensorial o frustración. No son comportamientos voluntarios.",
    recommendations: [
      "Reducir estímulos (ruido/luz)",
      "Mantener voz calmada",
      "No castigar durante la crisis"
    ],
    source: "Autismo Europa / OMS"
  },

  {
    id: "tea-4",
    category: "TEA",
    question: "¿Es normal que juegue solo todo el tiempo?",
    answer:
      "Muchos niños en el espectro prefieren el juego solitario debido a diferencias en interacción social.",
    recommendations: [
      "Introducir juego guiado",
      "Compartir actividades simples",
      "Respetar tiempos del niño"
    ],
    source: "ICBF"
  },

  {
    id: "tea-5",
    category: "TEA",
    question: "¿Los niños con autismo pueden aprender en colegio normal?",
    answer:
      "Sí, con apoyos adecuados pueden integrarse en educación inclusiva.",
    recommendations: [
      "Adaptaciones pedagógicas",
      "Apoyo docente",
      "Trabajo conjunto familia-escuela"
    ],
    source: "MEN Colombia"
  },

  {
    id: "tea-6",
    category: "TEA",
    question: "¿Por qué no mira a los ojos?",
    answer:
      "El contacto visual puede resultar incómodo o sobreestimulante para algunos niños con TEA.",
    recommendations: [
      "No forzar contacto visual",
      "Trabajar interacción gradual",
      "Usar apoyos visuales"
    ],
    source: "OMS"
  },

  {
    id: "tea-7",
    category: "TEA",
    question: "¿Qué terapias ayudan al TEA?",
    answer:
      "Las intervenciones dependen del caso, pero suelen incluir lenguaje, ocupacional y apoyo conductual.",
    recommendations: [
      "Terapia de lenguaje",
      "Terapia ocupacional",
      "Intervención temprana"
    ],
    source: "ICBF"
  },

  {
    id: "tea-8",
    category: "TEA",
    question: "¿El autismo tiene cura?",
    answer:
      "No es una enfermedad, por lo tanto no tiene cura. Es una condición del neurodesarrollo.",
    recommendations: [
      "Enfoque en habilidades",
      "Apoyo constante",
      "Inclusión educativa"
    ],
    source: "OMS"
  },

  {
    id: "tea-9",
    category: "TEA",
    question: "¿Por qué repite movimientos o palabras?",
    answer:
      "Esto se llama ecolalia o conductas repetitivas y es común en TEA.",
    recommendations: [
      "No interrumpir bruscamente",
      "Redirigir suavemente",
      "Observar detonantes"
    ],
    source: "ICBF"
  },

  {
    id: "tea-10",
    category: "TEA",
    question: "¿Cómo mejorar la comunicación?",
    answer:
      "Se recomienda usar comunicación visual y lenguaje simple.",
    recommendations: [
      "Pictogramas",
      "Frases cortas",
      "Rutinas visuales"
    ],
    source: "MEN Colombia"
  },

  // =========================
  // ⚡ TDAH
  // =========================
  {
    id: "tdah-1",
    category: "TDAH",
    question: "Mi hijo no se queda quieto, ¿es TDAH?",
    answer:
      "La hiperactividad por sí sola no es suficiente para diagnóstico. Debe evaluarse atención, impulsividad y funcionamiento diario.",
    recommendations: [
      "Evaluación profesional",
      "Rutinas estructuradas",
      "Reducir estímulos"
    ],
    source: "OMS"
  },

  {
    id: "tdah-2",
    category: "TDAH",
    question: "¿Cómo ayudar en casa a un niño con TDAH?",
    answer:
      "El apoyo debe centrarse en estructura, constancia y claridad.",
    recommendations: [
      "Instrucciones simples",
      "Refuerzo positivo",
      "Horarios fijos"
    ],
    source: "ICBF"
  },

  {
    id: "tdah-3",
    category: "TDAH",
    question: "¿Por qué se distrae fácilmente?",
    answer:
      "El cerebro con TDAH procesa estímulos de forma diferente, dificultando la atención sostenida.",
    recommendations: [
      "Ambiente sin distracciones",
      "Tareas cortas",
      "Pausas frecuentes"
    ],
    source: "OMS"
  },

  {
    id: "tdah-4",
    category: "TDAH",
    question: "¿Puede mejorar con el tiempo?",
    answer:
      "Con intervención adecuada, muchos niños mejoran significativamente sus habilidades.",
    recommendations: [
      "Terapia conductual",
      "Apoyo escolar",
      "Acompañamiento familiar"
    ],
    source: "ICBF"
  },

  {
    id: "tdah-5",
    category: "TDAH",
    question: "¿Es culpa de la crianza?",
    answer:
      "No. El TDAH es una condición neurobiológica, no un problema de crianza.",
    recommendations: [
      "Evitar culpas",
      "Apoyo profesional",
      "Educación familiar"
    ],
    source: "OMS"
  },
{
  id: "tdah-6",
  category: "TDAH",
  question: "¿El TDAH desaparece cuando el niño crece?",
  answer:
    "No desaparece, pero puede cambiar con el tiempo. Muchos niños aprenden estrategias para manejar la atención y la impulsividad.",
  recommendations: [
    "Apoyo terapéutico continuo",
    "Entrenamiento en autocontrol",
    "Seguimiento escolar"
  ],
  source: "OMS"
},

{
  id: "tdah-7",
  category: "TDAH",
  question: "¿Por qué mi hijo interrumpe constantemente?",
  answer:
    "La impulsividad hace que el niño responda antes de pensar, lo que se traduce en interrupciones frecuentes.",
  recommendations: [
    "Entrenar espera de turnos",
    "Refuerzo positivo",
    "Ejercicios de autocontrol"
  ],
  source: "ICBF"
},

{
  id: "tdah-8",
  category: "TDAH",
  question: "¿Los niños con TDAH son menos inteligentes?",
  answer:
    "No. El TDAH no está relacionado con la inteligencia. Es una diferencia en la regulación de la atención.",
  recommendations: [
    "Enfocarse en fortalezas",
    "Evitar etiquetas negativas",
    "Apoyo emocional"
  ],
  source: "OMS"
},

{
  id: "tdah-9",
  category: "TDAH",
  question: "¿Por qué olvida tareas o instrucciones?",
  answer:
    "La memoria de trabajo puede verse afectada, dificultando seguir instrucciones largas.",
  recommendations: [
    "Instrucciones paso a paso",
    "Apoyos visuales",
    "Repetición constante"
  ],
  source: "MEN Colombia"
},

{
  id: "tdah-10",
  category: "TDAH",
  question: "¿Qué pasa si no se trata el TDAH?",
  answer:
    "Puede generar dificultades escolares, emocionales y sociales, pero con apoyo temprano mejora significativamente.",
  recommendations: [
    "Intervención temprana",
    "Apoyo familiar",
    "Acompañamiento escolar"
  ],
  source: "OMS"
},

// =========================
  // 🗣 LENGUAJE
  // =========================
  {
    id: "len-1",
    category: "Lenguaje",
    question: "Mi hijo no habla a los 3 años",
    answer:
      "Puede ser una variación del desarrollo, pero requiere evaluación si no hay progreso.",
    recommendations: [
      "Estimulación diaria",
      "Lectura de cuentos",
      "Evitar pantallas"
    ],
    source: "MEN Colombia"
  },

  {
    id: "len-2",
    category: "Lenguaje",
    question: "Dice pocas palabras, ¿debo preocuparme?",
    answer:
      "Depende del contexto general del desarrollo del niño.",
    recommendations: [
      "Estimular comunicación",
      "No anticipar necesidades",
      "Consultar fonoaudiología"
    ],
    source: "ICBF"
  },

  {
    id: "len-3",
    category: "Lenguaje",
    question: "¿Cómo estimular el habla?",
    answer:
      "El lenguaje se estimula con interacción constante.",
    recommendations: [
      "Hablar todo el día",
      "Nombrar objetos",
      "Jugar imitando sonidos"
    ],
    source: "OMS"
  },
{
  id: "len-4",
  category: "Lenguaje",
  question: "¿A qué edad debe hablar un niño?",
  answer:
    "El desarrollo del lenguaje varía, pero la mayoría de niños dicen palabras alrededor del primer año y frases simples a los 2-3 años.",
  recommendations: [
    "Estimulación diaria",
    "Lectura en voz alta",
    "Interacción constante"
  ],
  source: "OMS"
},

{
  id: "len-5",
  category: "Lenguaje",
  question: "¿Qué causa el retraso del lenguaje?",
  answer:
    "Puede deberse a factores auditivos, ambientales o del neurodesarrollo.",
  recommendations: [
    "Evaluación auditiva",
    "Estimulación del habla",
    "Consulta fonoaudiológica"
  ],
  source: "MEN Colombia"
},

{
  id: "len-6",
  category: "Lenguaje",
  question: "¿Las pantallas afectan el lenguaje?",
  answer:
    "El uso excesivo de pantallas puede reducir la interacción necesaria para desarrollar el lenguaje.",
  recommendations: [
    "Reducir pantallas",
    "Más interacción humana",
    "Juego simbólico"
  ],
  source: "OMS"
},

{
  id: "len-7",
  category: "Lenguaje",
  question: "¿Por qué repite palabras?",
  answer:
    "Puede ser parte del aprendizaje o una etapa del desarrollo del lenguaje.",
  recommendations: [
    "Modelar lenguaje correcto",
    "No corregir de forma brusca",
    "Estimulación constante"
  ],
  source: "ICBF"
},

{
  id: "len-8",
  category: "Lenguaje",
  question: "¿Qué hacer si no entiende instrucciones?",
  answer:
    "Puede tener dificultades en comprensión del lenguaje receptivo.",
  recommendations: [
    "Frases cortas",
    "Apoyos visuales",
    "Repetición"
  ],
  source: "MEN Colombia"
},

{
  id: "len-9",
  category: "Lenguaje",
  question: "¿El bilingüismo retrasa el habla?",
  answer:
    "No. Los niños pueden aprender dos idiomas sin retraso si hay exposición adecuada.",
  recommendations: [
    "Exposición constante",
    "No mezclar ansiedad",
    "Juegos lingüísticos"
  ],
  source: "OMS"
},

{
  id: "len-10",
  category: "Lenguaje",
  question: "¿Cuándo debo preocuparme?",
  answer:
    "Si a los 3 años hay muy pocas palabras o no hay intención comunicativa.",
  recommendations: [
    "Consulta fonoaudiología",
    "Evaluación del desarrollo",
    "Estimulación temprana"
  ],
  source: "ICBF"
},

// =========================
  // 🌍 NEURODIVERSIDAD
  // =========================
  {
    id: "neu-1",
    category: "Neurodiversidad",
    question: "¿Qué es la neurodiversidad?",
    answer:
      "Es el reconocimiento de que el cerebro humano tiene variaciones naturales como autismo o TDAH.",
    recommendations: [
      "Enfoque inclusivo",
      "Evitar estigmas",
      "Apoyo temprano"
    ],
    source: "OMS"
  },

  {
    id: "neu-2",
    category: "Neurodiversidad",
    question: "¿Se debe tratar como enfermedad?",
    answer:
      "No. Son condiciones del neurodesarrollo, no enfermedades.",
    recommendations: [
      "Comprensión",
      "Inclusión",
      "Acompañamiento"
    ],
    source: "OMS"
  },
{
  id: "neu-3",
  category: "Neurodiversidad",
  question: "¿La neurodiversidad es un diagnóstico?",
  answer:
    "No. Es un concepto que reconoce la diversidad natural del cerebro humano.",
  recommendations: [
    "Enfoque inclusivo",
    "Evitar estigmatización",
    "Educación familiar"
  ],
  source: "OMS"
},

{
  id: "neu-4",
  category: "Neurodiversidad",
  question: "¿Autismo y TDAH son enfermedades?",
  answer:
    "No. Son condiciones del neurodesarrollo, no enfermedades.",
  recommendations: [
    "Comprensión",
    "Apoyo temprano",
    "Inclusión"
  ],
  source: "OMS"
},

{
  id: "neu-5",
  category: "Neurodiversidad",
  question: "¿Se puede vivir normalmente con neurodivergencia?",
  answer:
    "Sí, con apoyos adecuados pueden desarrollarse plenamente.",
  recommendations: [
    "Adaptaciones",
    "Apoyo educativo",
    "Acompañamiento familiar"
  ],
  source: "ICBF"
},

{
  id: "neu-6",
  category: "Neurodiversidad",
  question: "¿Qué significa ser neurodivergente?",
  answer:
    "Significa tener un cerebro que procesa información de forma diferente a lo típico.",
  recommendations: [
    "Aceptar diferencias",
    "Fortalecer habilidades",
    "Evitar etiquetas negativas"
  ],
  source: "OMS"
},

{
  id: "neu-7",
  category: "Neurodiversidad",
  question: "¿Se debe corregir la neurodivergencia?",
  answer:
    "No se “corrige”, se acompaña y se apoya según las necesidades.",
  recommendations: [
    "Intervención respetuosa",
    "Apoyo individualizado",
    "Inclusión"
  ],
  source: "OMS"
},

{
  id: "neu-8",
  category: "Neurodiversidad",
  question: "¿La neurodiversidad afecta el aprendizaje?",
  answer:
    "Puede influir en la forma de aprender, pero no impide aprender.",
  recommendations: [
    "Métodos adaptados",
    "Apoyo escolar",
    "Refuerzo positivo"
  ],
  source: "MEN Colombia"
},

{
  id: "neu-9",
  category: "Neurodiversidad",
  question: "¿Es una moda hablar de neurodiversidad?",
  answer:
    "No. Es un enfoque reconocido en salud y educación inclusiva.",
  recommendations: [
    "Educación basada en evidencia",
    "Inclusión social",
    "Respeto"
  ],
  source: "OMS"
},

{
  id: "neu-10",
  category: "Neurodiversidad",
  question: "¿Qué beneficios tiene entender la neurodiversidad?",
  answer:
    "Permite mejorar la inclusión, reducir el estigma y apoyar mejor a los niños.",
  recommendations: [
    "Mejor convivencia",
    "Apoyo emocional",
    "Educación inclusiva"
  ],
  source: "ICBF"
}
];